import { render, staticRenderFns } from "./RulePath.vue?vue&type=template&id=5c97fde2&scoped=true&"
import script from "./RulePath.vue?vue&type=script&lang=js&"
export * from "./RulePath.vue?vue&type=script&lang=js&"
import style0 from "./RulePath.vue?vue&type=style&index=0&id=5c97fde2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c97fde2",
  null
  
)

export default component.exports